import { useScheduledMessages } from '@/hooks/useScheduledMessages';

/**
 * Renders nothing — just runs the useScheduledMessages hook.
 * Must be rendered inside <MessagingSocketProvider>.
 */
export function ScheduledMessagesProcessor() {
  useScheduledMessages();
  return null;
}
